export const CLOSE_FILE = 'file/CLOSE_FILE';
export const CHANGE_FILE = 'file/CHANGE_FILE';
export const FILE_FETCH = 'file/FILE_FETCH';
export const FILE_FETCH_SUCCESS = 'file/FILE_FETCH_SUCCESS';
export const FILE_FETCH_FAILURE = 'file/FILE_FETCH_FAILURE';
export const SET_RESULT_DETAIL_CONFIG = 'file/SET_RESULT_DETAIL_CONFIG';
export const SET_RESULT_DETAIL_PROJECT_CONFIG =
  'file/SET_RESULT_DETAIL_PROJECT_CONFIG';
export const SET_TABLE_CONFIG = 'file/SET_TABLE_CONFIG';
